import { render, staticRenderFns } from "./ChatAutomatedMindSelect.vue?vue&type=template&id=dea9b602&scoped=true"
import script from "./ChatAutomatedMindSelect.vue?vue&type=script&lang=js"
export * from "./ChatAutomatedMindSelect.vue?vue&type=script&lang=js"
import style0 from "./ChatAutomatedMindSelect.vue?vue&type=style&index=0&id=dea9b602&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea9b602",
  null
  
)

export default component.exports